<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>短途运输结算单据使用说明:<br>
					<span>1、单号构成规则:201201+JS+4位顺序号。系统生成,添加无效</span><br>
					<span>2、提交后完成。</span><br>
					<span>3、查询关键字:单号、车牌、开始日期、截至日期、装货点、客户姓名、司机、状态。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			
		</pre-base>
		
	</div>
</template>

<script>
	import {
		GetShort
	} from '@/utils/localstore.js';

	import api from '@/utils/type.js';
	import {
		Method_Common
	} from '@/utils/loadhttpdata.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view_v2.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';

				this.init_data = JSON.stringify({
					"control": "trans_pay_m",
					"title": "	结算管理",
					"isTwo": "1",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"isShowEdit": "1",
					"step": "0",
					"sel_action": 'exp_dtys_pay_m_sel',
					"upd_action": 'exp30_dtys_pay_m',
					"detail_part": "1",
					"detail_excelup": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_dtys_pay_d_over',
					"d_upd_action": '_dtys_trans_short_over_d_',
					"file_action": 'filemore',
					"p1": 'ys',
					"p2": 'dt',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "车牌",
							"val": "",
							"key": "car_no",
							"type": "text",
							"class": "long1",
							"sel": "2"
						},
						{
							"name": "开始结算",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"sel": "3"
						},
						{
							"name": "截至结算",
							"val": "",
							"key": "e_date",
							"type": "date",
							"class": "long1",
							"sel": "4"
						},
						{
							"name": "装货地点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"sel": "5"
						},
						{
							"name": "客户姓名",
							"val": "",
							"key": "c_name",
							"type": "text",
							"class": "long1",
							"sel": "6"
						},
						{
							"name": "司机姓名",
							"val": "",
							"key": "driver",
							"type": "text",
							"class": "long1",
							"sel": "7"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel": "8"
						}
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "截止日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "客户",
							"val": "",
							"key": "c_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_company",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},

						{
							"name": "经办人",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"

						},
						{
							"name": "应结总额",
							"val": "",
							"key": "amount_all",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "已结总额",
							"val": "",
							"key": "amount_ok",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},
						{
							"name": "未结总额",
							"val": "",
							"key": "amount_no",
							"type": "label",
							"class": "long1",
							"p": "0",
							"w": "0",
							"r": "0",
							"x": "4"
						},

						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "客户名称"
						},
						{
							"name": "开始结算"
						},
						{
							"name": "截至结算"
						},
						{
							"name": "经办人"
						},
						{
							"name": "应结金额"
						},
						{
							"name": "已结金额"
						},
						{
							"name": "未结金额"
						},

						{
							"name": "备注"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "修改时间"
						}, 
						{
							"name": "附件"
						},
					],
					"d_parm": [{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "结算日期",
							"val": "",
							"key": "pay_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "pay_note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "结算日期"
						},
						{
							"name": "金额"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "附件"
						},
						
						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});


			},
			refresh_data: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}







		}
	};
</script>
<style>
</style>